const sessions = {
  sessionBlocked:
    "Sie wurden abgemeldet, da von einem anderen Gerät auf Ihr Konto zugegriffen wurde.",
  sessionWarning: "Wenn Sie das nicht waren, ändern Sie bitte Ihr Passwort.",
  sessionTabDisabled: "Dieser Tab ist deaktiviert.",
  sessionTabOpened: "Ihr Konto ist bereits in einem anderen Tab geöffnet.",
  sessionCloseTab: "Sie können diesen Tab schließen.",
  sessionUniqueWarning: "iizenglish kann jeweils nur in einem Tab aktiv sein.",
};

export default sessions;
